import React from "react";

export default function Video() {
  return (
    <div className="video">
      <iframe
        className="video__iframe"
        src="https://www.youtube.com/embed/tgbNymZ7vqY"
      ></iframe>
    </div>
  );
}
